<template>
  <div id="pageRoot">
    <span class="normalTheme pageInstruction" style="left: 65px; top: 118px">
      <p>Completa cada enunciado eligiendo una de estas palabras:</p>
    </span>

    <p id="tag01" class="textBase basicItem01 tagDefault">CUANDO</p>
    <p id="tag02" class="textBase basicItem01 tagDefault">COMO</p>
    <p id="tag03" class="textBase basicItem01 tagDefault">PORQUE</p>

    <h2 id="text01" class="textBase textFormat">
      Los sapos y las ranas "cantan"<br />los seres humanos.
    </h2>
    <h2 id="text02" class="textBase textFormat">
      Su canto se escucha fuerte desde lejos<br />tienen un saco vocal que sirve
      de caja de resonancia
    </h2>
    <h2 id="text03" class="textBase textFormat">
      Se los escucha cantar en primavera<br />se aparean.
    </h2>

    <saved-input
      v-bind:page="$parent.page"
      v-bind:type="$parent.type"
      number="1"
      id="inputField01"
      class="pageElement"
    />
    <saved-input
      v-bind:page="$parent.page"
      v-bind:type="$parent.type"
      number="2"
      id="inputField02"
      class="pageElement"
    />
    <saved-input
      v-bind:page="$parent.page"
      v-bind:type="$parent.type"
      number="3"
      id="inputField03"
      class="pageElement"
    />
  </div>
</template>
<style scoped>
#bg {
  position: absolute;
  left: 62px;
  top: 112px;
}

#tag01 {
  position: absolute;
  width: 180px;
  text-align: center;
  left: 103px;
  top: 204px;
}
#tag02 {
  position: absolute;
  width: 180px;
  text-align: center;
  left: 338px;
  top: 204px;
}
#tag03 {
  position: absolute;
  width: 180px;
  text-align: center;
  left: 576px;
  top: 204px;
}

#text01 {
  position: absolute;
  left: 95px;
  top: 327px;
}
#text02 {
  position: absolute;
  left: 95px;
  top: 457px;
}
#text03 {
  position: absolute;
  left: 95px;
  top: 606px;
}
.textFormat {
  font-size: 29px;
  text-transform: uppercase;
  line-height: 1.6;
}

#inputField01 {
  position: absolute;
  width: 180px;
  height: 40px;
  left: 584px;
  top: 319px;
}
#inputField02 {
  position: absolute;
  width: 180px;
  height: 40px;
  left: 721px;
  top: 438px;
}
#inputField03 {
  position: absolute;
  width: 180px;
  height: 40px;
  left: 672px;
  top: 591px;
}
</style>
<script>
export default {
  data() {
    return {
      videos: [
        "glo/Video 149.mp4",
        "glo/Video 150.mp4",
        "glo/Video 151.mp4",
        "glo/Video 152.mp4",
        "glo/Video 153.mp4",
        ],
    };
  },
};
</script>